import _main from "./lib/main";
export { _main as default };
export const CustomException = _main.CustomException,
      NotImplementedException = _main.NotImplementedException,
      InvalidInitialization = _main.InvalidInitialization,
      BadRequest = _main.BadRequest;